module.exports = __webpack_public_path__ + "static/media/toggleIcon.d9c02485.svg";